import PropTypes from 'prop-types';
import React from 'react';

import { ByteSize } from './byte-size';
import dayjs from 'dayjs';

class DownloadItem extends React.Component {
  render() {
    return (
      <a
        href={this.props.url}
        className="cursor-pointer round-bold border border--transparent border--blue-on-active bg-white shadow-darken10 shadow-darken10-bold-on-hover transition px12 py12 mb24 flex-parent flex-parent--center-cross flex-parent--space-between-main"
      >
        <div className="flex-child txt-truncate">
          <span title={this.props.id}>{this.props.id}</span>
        </div>
        <div className="flex-child txt-truncate txt-xs py12 px12">
          {this.props.tag && (
            <span className="mr12 bg-darken5 px6 inline-block round">
              {this.props.tag}
            </span>
          )}
          <span className="mr12">
            <ByteSize raw={this.props.size} />
          </span>
          <span>{dayjs(this.props.date).format('YYYY-MM-DD')}</span>
        </div>
      </a>
    );
  }
}

DownloadItem.propTypes = {
  size: PropTypes.number.isRequired,
  tag: PropTypes.string,
  date: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export { DownloadItem };
